import { initCookieBanner as initBanner } from '@nocn/cookie-policy-banner';
import { initAnalytics } from './Analytics';

const initCookieBanner = () => {
  initBanner({
    apiKey: process.env.REACT_APP_CIVIC_UK_API_KEY,
    product: 'PRO_MULTISITE',
    policyUrl: 'https://www.nocn.org.uk/privacy/',
    necessaryCookies: ['CookieControl'],
    optionalCookies: [
      {
        name: 'analytics',
        label: 'Analytical Cookies',
        description:
          'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
        cookies: ['_ga*', '_gid*', '_gat*'],
        onAccept: () => {
          initAnalytics();
        },
        onRevoke: () => {
          document.cookie.split(';').forEach((cookie) => {
            const name = cookie.split('=')[0].trim();
            if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
              window.CookieControl.delete(name);
            }
          });
        },
      },
    ],
    onLoad: () => {
      // Check existing consent and initialize analytics if already accepted
    },
    onError: (error) => {
      console.error('CookieBanner error:', error);
    },
  });
};

export default initCookieBanner;
